import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const NavigatorIcon = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25503 12.198L11.2063 3.0483C12.2646 1.09249 15.2463 2.08503 14.9212 4.28496L14.2397 8.89774L15.7025 8.73522L15.807 9.67606L15.9115 10.6169L13.2283 10.9151C12.6114 10.9836 12.0966 10.4499 12.1873 9.83584L13.0483 4.00824C13.0638 3.90348 12.9218 3.85622 12.8714 3.94935L7.92015 13.099C7.84742 13.2334 7.95568 13.3942 8.10757 13.3773L10.8039 13.0777C11.4157 13.0097 11.9286 13.5344 11.8467 14.1445L11.0617 19.9934C11.0477 20.0981 11.1896 20.1437 11.2391 20.0504L16.0997 10.8939C16.171 10.7595 16.0627 10.6001 15.9115 10.6169L15.807 9.67606L15.7025 8.73522C17.3657 8.55042 18.5566 10.3034 17.772 11.7815L12.9114 20.9381C11.8715 22.8971 8.89023 21.9397 9.18525 19.7416L9.80911 15.0932L8.31664 15.259C6.64589 15.4446 5.455 13.6764 6.25503 12.198Z"
      fill="currentColor"
    />
  </>,
  "NavigatorIcon"
);
